module.exports = __webpack_public_path__ + "img/miota.70c67b29.svg";